import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Dtfprinting from "./sections/Dtfprinting";
import Advantage from "./sections/Advantage";
import Categories from "./sections/Categories";
import FeaturedPrints from "./sections/FeaturedPrints";
import Standards from "./sections/Standards";
import Ready from "./sections/Ready";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Dtfprinting />
      <Advantage />
      <Categories />
      <FeaturedPrints />
      <Standards />
      <Ready />
      <Footer />
    </div>;
}